/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import YouTube from 'react-youtube';
import { MdBeenhere } from 'react-icons/md';
import { toast } from 'react-toastify';
import Slider from 'react-rangeslider';
import AceEditor from 'react-ace';

import 'react-rangeslider/lib/index.css';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-dracula';

import { Container, Card, Challenge, ChallengeCode } from './styles';
import api from '~/services/api';

export default function Timeline() {
  const { id } = useParams();
  const [module, setModule] = useState({});
  const [cards, setCards] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const user = useSelector((state) => state.user.profile);
  const [answer, setAnswer] = useState('');
  const [grade, setGrade] = useState(5.5);
  const [code, setCode] = useState('');
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    async function getDataModule() {
      const { data } = await api.get(`/modules/${id}`);
      setModule(data);
    }

    async function getDataCards() {
      const { data } = await api.get(`/modules/${id}/contents`);
      setCards(data);
    }

    async function getDataChallenges() {
      const { data } = await api.get(`/modules/${id}/challenges`);
      setChallenges(data);
    }

    getDataModule();
    getDataCards();
    getDataChallenges();
  }, [id]);

  const opts = {
    height: '390',
    width: '100%',
  };

  function handleShowVideo() {
    return showVideo === false ? setShowVideo(true) : setShowVideo(false);
  }

  function onLoad() {}

  function onChangeCode(newValue) {
    setCode(newValue);
  }

  const handleInputChange = (e) => {
    const { value } = e.target;
    setAnswer(value);
  };

  async function handleSubmit(e, idChallenge) {
    e.preventDefault();

    try {
      if (answer) {
        await api.post(`challenges/${idChallenge}/scorecards/`, {
          user_id: user.id,
          link_answer: answer,
        });

        return toast.success('Desafio enviado com sucesso!');
      }
      return toast.error('Preencha o campo de resposta e tente novamente.');
    } catch (error) {
      return toast.warn('Desafio já enviado, veja sua página de desafios.');
    }
  }

  async function handleSubmitCode(e, idChallenge) {
    e.preventDefault();

    try {
      if (code.length > 5) {
        await api.post(`challenges/${idChallenge}/scorecards`, {
          user_id: user.id,
          code_answer: code,
          link_answer: '.',
        });
        return toast.success('Desafio enviado com sucesso!');
      }
      return toast.error('Preencha o campo de resposta e tente novamente.');
    } catch (error) {
      return toast.error('Desafio já enviado, veja sua página de desafios.');
    }
  }

  async function handleVote(e, idCard) {
    e.preventDefault();

    if (grade) {
      try {
        await api.post('cards/rating', {
          ratings: grade,
          content_id: idCard,
        });
        return toast.success('Voto enviado com sucesso!');
      } catch (error) {
        return toast.warn('Conteúdo já avaliado');
      }
    }
    return toast.error('Erro ao enviar o seu voto, tente novamente.');
  }
  return (
    <>
      <p
        style={{
          fontSize: 28,
          color: '#36DED6',
          marginTop: 30,
          fontWeight: 'bold',
          paddingLeft: 40,
        }}
      >
        {module.title}
      </p>
      <p
        style={{
          fontSize: 18,
          color: '#36DED6',
          marginTop: 10,
          paddingLeft: 40,
        }}
      >
        {module.objective}
      </p>
      <Container>
        <p
          style={{
            fontSize: 28,
            paddingLeft: 40,
            marginTop: 30,
            fontWeight: 'bold',
          }}
        >
          Desafios:
        </p>

        {challenges.map((challenge, index) => {
          if (challenge.type === 'theory') {
            return (
              <Challenge key={challenge.id}>
                <div className="tag">
                  <div>
                    <MdBeenhere size={35} color="#FFF" />
                  </div>
                </div>
                <h2 style={{ marginTop: -35 }}>
                  {challenge.title} #{index + 1}
                </h2>
                <p
                  style={{
                    textAlign: 'justify',
                    margin: 10,
                    lineHeight: 1.5,
                    fontSize: 16,
                  }}
                >
                  {challenge.question}
                </p>

                <form>
                  <input
                    type="text"
                    placeholder="Escreva sua resposta"
                    value={answer}
                    onChange={handleInputChange}
                  />
                  <button
                    type="submit"
                    onClick={(e) => handleSubmit(e, challenge.id)}
                  >
                    ENVIAR
                  </button>
                </form>
              </Challenge>
            );
          }
          return (
            <ChallengeCode key={challenge.id}>
              <div className="tag">
                <div>
                  <MdBeenhere size={35} color="#FFF" />
                </div>
              </div>
              <h2 style={{ marginTop: -35 }}>
                {challenge.title} #{index + 1}
              </h2>
              <p
                style={{
                  textAlign: 'justify',
                  margin: 10,
                  lineHeight: 1.5,
                  fontSize: 16,
                }}
              >
                {challenge.question}
              </p>

              <div className="ace">
                <AceEditor
                  placeholder="Placeholder Text"
                  mode={`${challenge.language}`}
                  theme="dracula"
                  name={challenge.id}
                  onLoad={onLoad}
                  onChange={onChangeCode}
                  fontSize={14}
                  showPrintMargin
                  showGutter
                  highlightActiveLine
                  value={code}
                  width="700px"
                  height="400px"
                  setOptions={{
                    enableBasicAutocompletion: true,
                    enableLiveAutocompletion: true,
                    enableSnippets: true,
                    showLineNumbers: true,
                    tabSize: 2,
                  }}
                />
              </div>
              <button
                type="submit"
                onClick={(e) => handleSubmitCode(e, challenge.id)}
              >
                ENVIAR
              </button>
            </ChallengeCode>
          );
        })}

        <button type="button" onClick={handleShowVideo}>
          Tem alguma ajuda?
        </button>

        {showVideo === true ? (
          cards.length >= 1 ? (
            cards.map((item, index) => {
              if (item.youtube_code === '.') {
                return (
                  <Card key={item.id}>
                    <div className="tag">
                      <div>{index + 1}</div>
                    </div>
                    <h2 style={{ marginTop: -35 }}>{item.title}</h2>
                    <p
                      style={{
                        textAlign: 'justify',
                        margin: 10,
                        lineHeight: 1.5,
                        fontSize: 16,
                      }}
                    >
                      {item.content}
                    </p>
                    <div className="link">
                      <a
                        href={`${item.link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: '#fff',
                          fontWeight: 'bold',
                          fontSize: 18,
                          borderStyle: 'solid',
                          borderWidth: 1,
                          borderColor: '#Fff',
                          padding: 10,
                          textAlign: 'center',
                          marginLeft: 100,
                          borderRadius: 10,
                        }}
                      >
                        Clique aqui para acessar o conteúdo
                      </a>
                    </div>
                    <p style={{ marginTop: 30 }}>
                      Creditos: {item.source}, {item.channel}
                    </p>
                    <div className="slider">
                      <p>Avalie o conteúdo (1 à 10):</p>
                      <div className="support">
                        <Slider
                          value={grade}
                          min={1}
                          max={10}
                          orientation="horizontal"
                          onChange={
                            index + 1 === item.position
                              ? (value) => setGrade(value)
                              : null
                          }
                          labels={{ 1: 'Péssimo', 5: 'Regular', 10: 'Ótimo' }}
                        />

                        <button
                          type="submit"
                          onClick={(e) => handleVote(e, item.id)}
                        >
                          VOTAR
                        </button>
                      </div>
                    </div>
                  </Card>
                );
              }
              return (
                <Card key={item.id}>
                  <div className="tag">
                    <div>{index + 1}</div>
                  </div>
                  <h2 style={{ marginTop: -35 }}>{item.title}</h2>
                  <p
                    style={{
                      textAlign: 'justify',
                      margin: 10,
                      lineHeight: 1.5,
                      fontSize: 16,
                    }}
                  >
                    {item.content}
                  </p>
                  <div style={{ margin: 30 }}>
                    <YouTube videoId={`${item.youtube_code}`} opts={opts} />
                  </div>
                  <p>
                    Creditos: {item.source}, {item.channel}
                  </p>
                  <div className="slider">
                    <p>Avalie o conteúdo (1 à 10):</p>
                    <div className="support">
                      <Slider
                        value={grade}
                        min={1}
                        max={10}
                        orientation="horizontal"
                        onChange={
                          index + 1 === item.position
                            ? (value) => setGrade(value)
                            : null
                        }
                        labels={{ 1: 'Péssimo', 5.5: 'Regular', 10: 'Ótimo' }}
                      />

                      <button
                        type="submit"
                        onClick={(e) => handleVote(e, item.id)}
                      >
                        VOTAR
                      </button>
                    </div>
                  </div>
                </Card>
              );
            })
          ) : (
            <p style={{ marginTop: 30, fontSize: 20 }}>Por enquanto nāo...</p>
          )
        ) : null}

        <div style={{ height: 450 }} />
      </Container>
    </>
  );
}
